import { useScrollReveal } from '../../../hooks/useScrollReveal';
import { problems } from '../../../mocks/asesoriaImagen';

export default function ProblemsSection() {
  const { ref, style } = useScrollReveal({
    threshold: 0.1,
    distance: 32,
    duration: 800,
  });
  const { ref: refGrid, style: styleGrid } = useScrollReveal({
    threshold: 0.1,
    distance: 28,
    duration: 800,
    delay: 200,
  });

  return (
    <section className="w-full bg-brand-cream py-20 md:py-28 px-6 lg:px-[7%]">
      <div ref={ref} style={style} className="max-w-3xl">
        <span className="font-sans text-brand-gray-500 text-[11px] tracking-[0.2em] uppercase font-medium">
          El problema
        </span>
        <h2 className="font-serif text-brand-black text-[clamp(1.8rem,4vw,2.8rem)] leading-[1.3] mt-4">
          Tu imagen está costándote más de lo que crees
        </h2>
      </div>
      <div
        ref={refGrid}
        style={styleGrid}
        className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mt-12"
      >
        {problems.map((p) => (
          <div
            key={p.id}
            className="bg-white rounded-2xl p-6 md:p-8 border border-brand-gray-200"
          >
            <div className="w-10 h-10 rounded-full bg-brand-sage/40 flex items-center justify-center mb-5">
              <span className="font-serif text-brand-black text-lg font-medium">
                0{p.id}
              </span>
            </div>
            <h3 className="font-serif text-brand-black text-lg font-medium">
              {p.title}
            </h3>
            <p className="font-sans text-brand-gray-500 text-sm leading-relaxed mt-3">
              {p.description}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}